<template>
  <v-row class="text-left pl-3">
    <text-view
        :display="profile.ogrn"
        multiline
        md="6"
        :label="$t('ОГРН')" />
    <text-view
        :display="profile.phone"
        multiline
        md="6"
        :label="$t('Контактный телефон')"
        prepend-icon="settings_phone" />
    <text-view
        :display="$t(profile.isTopManager
          ? 'Да'
          : 'Нет')"
        multiline
        md="6"
        :label="$t('Уполномоченным представителем является Единоличный исполнительный орган')" />
    <text-view
        :display="profile.contactPerson"
        multiline
        md="6"
        :label="$t('Контактное лицо')"
        prepend-icon="person" />
    <text-view
        :display="profile.documentPersonIdentity"
        multiline
        md="6"
        :label="$t('Серия и номер паспорта')"
        prepend-icon="assignment_ind" />
    <text-view
        :display="$t(SUBSCRIPTIONS_TYPE_ENUM[profile.subscriptionsStatus])"
        multiline
        md="6"
        :label="$t('Подписка на рассылку')"
        prepend-icon="mail" />
  </v-row>
</template>

<script>
  import TextView from '@/components/reused/ui/TextView.vue'
  import { SUBSCRIPTIONS_TYPE_ENUM } from '@/constants/enums'

  export default {
    components: {
      TextView
    },
    props: {
      profileInfo: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        SUBSCRIPTIONS_TYPE_ENUM
      }
    },
    computed: {
      profile () {
        const personIdentity = this.profileInfo.documentPersonIdentity
        return {
          ...this.profileInfo,
          documentPersonIdentity: personIdentity
            ? `${personIdentity.substring(0, 4)} ${personIdentity.substring(4)}`
            : null
        }
      }
    }
  }
</script>
